<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row dense>
        <v-col cols="12">
          <h1 class="primary--text font-weight-medium">
            {{ $t('transfer_summary') }}
          </h1>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-list dense>
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title class="item-text primary--text text-body-1">
                      {{ $t('transfer_alias') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon class="mr-sm-5 d-none d-sm-flex" v-text="'mdi-chevron-right'" color="primary"/>
                    <v-list-item-subtitle class="ml-sm-5 primary--text item-text text-body-1">
                      {{ permanentInstruction.alias }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_name') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ permanentInstruction.beneficiary }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item
              v-if="permanentInstruction.trType !== 'avsInternal'"
              class="pl-0"
            >
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_beneficiary_data') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      <span v-if="permanentInstruction.bnfEmail">{{ permanentInstruction.bnfEmail}}</span>
                      <span v-if="permanentInstruction.bnfPhone">{{ permanentInstruction.bnfPhone}} </span>
                      <span v-if="permanentInstruction.bnfAddres1">{{ permanentInstruction.bnfAddres1 }} {{ permanentInstruction.bnfAddres2 }} - </span>
                      <span v-if="permanentInstruction.bnfCountry">{{ permanentInstruction.bnfCountry }} {{ permanentInstruction.bnfState }} {{ permanentInstruction.bnfCity }}, {{ permanentInstruction.bnfZipcode }}</span>
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="permanentInstruction.trType !== 'avsInternal'"
              class="silver"
            />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_account_type') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ $t(permanentInstruction.accountType.t) }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_financial_institution_of_beneficiary') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ permanentInstruction.bnfBankName }} - {{ permanentInstruction.bnfBankAccNumber }}
                      <span v-if="permanentInstruction.accountType.value !== 'nfiAccount'">
                        <span v-if="permanentInstruction.bnfBankABA">ABA/SWIFT {{ permanentInstruction.bnfBankABA }} </span>
                        <span v-if="permanentInstruction.bnfBankAddres1">- {{ permanentInstruction.bnfBankAddres1 }} {{ permanentInstruction.bnfBankAddres2 }}</span>
                        <span v-if="permanentInstruction.bnfBankCountry"> {{ permanentInstruction.bnfBankCountry }} {{ permanentInstruction.bnfBankState }} {{ permanentInstruction.bnfBankCity }}</span>
                      </span>
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item v-if="permanentInstruction.nfiName" class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_receiving_bank') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ permanentInstruction.nfiName }} - {{ permanentInstruction.nfiAccountNumber }} <span v-if="permanentInstruction.bnfBankABA">- ABA/SWIFT {{ permanentInstruction.bnfBankABA }} -</span> {{ permanentInstruction.bnfBankCity }} {{ permanentInstruction.bnfBankCountry }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="permanentInstruction.nfiName" class="silver" />
            <v-list-item
              v-if="permanentInstruction.intermBankIsUsed"
              class="pl-0"
            >
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_intermediary') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ permanentInstruction.intermBankName }} - {{ permanentInstruction.intermBankAccNumber }}
                      <span v-if="permanentInstruction.intermBankABA">ABA/SWIFT {{ permanentInstruction.intermBankABA }} </span>
                      <span v-if="permanentInstruction.intermBankAddres1">- {{ permanentInstruction.intermBankAddres1 }} {{ permanentInstruction.intermBankAddres2 }}</span>
                      <span v-if="permanentInstruction.intermBankCountry"> {{ permanentInstruction.intermBankCountry }} {{ permanentInstruction.intermBankState }} {{ permanentInstruction.intermBankCity }}</span>
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="permanentInstruction.intermBankIsUsed"
              class="silver"
            />
            <v-list-item
              v-if="permanentInstruction.intermBankIsUsed"
              class="pl-0"
            >
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_intermediary_observations') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ permanentInstruction.intermReference }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="permanentInstruction.intermBankIsUsed"
              class="silver"
            />
            <v-list-item class="pl-0 item-text primary--text">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_observations') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ permanentInstruction.bnfReference }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver"></v-divider>
            <v-list-item class="pl-0 item-text primary--text">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_instructions') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ permanentInstruction.avsInternalRemark }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
          </v-list>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col v-if="isRedirect" cols="12">
          <v-switch
            v-model="addInstructionToDirectory"
            :label="$t('instructions_permanent_is_temporary')"
            hide-details
            @change="handleInstructionToDirectory"
          />
        </v-col>
        <v-col cols="12">
          <ValidationProvider
            :name="$t('transfer_accordance_title')"
            :rules="{ required: { allowFalse: false } }"
            v-slot="{ errors }"
          >
            <v-checkbox
              v-model="accordance"
              class="py-0"
              :error-messages="errors[0]"
            >
              <template v-slot:label>
                <div class="agreement-text text-body-1">
                  <span>{{ $t('transfer_accordance_title') }}: </span>
                  <span>{{ $t('transfer_accordance_authorization') }}</span>
                  <br />
                  <span>{{ $t('transfer_accordance_agreement') }}</span>
                </div>
              </template>
            </v-checkbox>
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
export default {
  components: {
    WizardForm
  },
  props: {
    permanentInstruction: {
      type: [Object],
      require: true
    }
  },
  data() {
    return {
      addInstructionToDirectory: false,
      accordance: false,
      stepFour: {
        adress: ['Address 1', 'Address 2'],
        name: 'Name',
        city: 'City',
        codePostal: 'Zip Code',
        observation: 'Observations',
        country: 'Country',
        state: 'State',
        creditPost: 'Back Credit'
      }
    }
  },
  computed: {
    isRedirect() {
      return this.$route.query?.redirect?.length
    }
  },
  mounted() {
    if (this.isRedirect) {
      this.permanentInstruction.isTemporary = true
    }
  },
  methods: {
    handleInstructionToDirectory(value) {
      this.permanentInstruction.isTemporary = !value
    }
  }
}
</script>
<style lang="sass" scoped>
.agreement-text
  color: #B0B0B2

.main-container
  line-height: normal

.item-text
  font-size: 1.143rem

hr
  margin: 0
  padding: 0

hr.rounded
  border-top: 2px solid
  width: 250px
</style>
